import { useCallback } from 'react';

export const useRelevantTraps = () => {
  const getRelevantTraps = useCallback(
    (trappingZone, selectedInsectGroup) =>
      trappingZone.traps.filter((trap) =>
        trap.trap_lure.insects.some(
          (insect) => insect.insect_group.id === selectedInsectGroup.id
        )
      ),
    []
  );

  return getRelevantTraps;
};
